import {useState, useEffect, useRef} from "react";
import {Checkbox, Button} from "parts";
import {SurveyEnum} from "_business";

export function ChoiceList({children, index, survey, checkedList, className, onChange}) {
  const
    [state, setState] = useState({
      checkedList: []
    }),
    listRef = useRef(null)

  useEffect(() => {
    if (listRef.current) {
      listRef.current.classList.add('animate-choice')

      setTimeout(() => {
        if (listRef.current)
          listRef.current.classList.remove('animate-choice')
      }, 500)
    }
  }, [(index >= 0 ? index : survey), listRef.current])

  useEffect(() => {
    state.checkedList = checkedList ? [...checkedList] : []
    setState({...state})
  }, [checkedList])

  function handleSelect(item, index) {
    if (state.checkedList.includes(index)) {
      // if (survey.type && survey.type !== SurveyEnum.boolean) {
      if (survey.multiple) {
        const ind = state.checkedList.findIndex(i => i === index)
        state.checkedList.splice(ind, 1)
      }
    } else {
      if (survey.multiple)
        state.checkedList.push(index)
      else
        state.checkedList = [index]
    }

    onChange(state.checkedList)
    setState({...state})
  }

  const isChecked = (index) => {
    return state.checkedList.includes(index)
  }

  let cls = 'choice-list animate-choice ' + (survey.type === SurveyEnum.pic ? 'type-' + SurveyEnum.line + ' ' : '') + 'type-' + survey.type + (className ? ' ' + className : '')

  if (survey.multiple)
    cls += ' multiple'

  return (
    <div ref={listRef} className={cls}>
      {
        survey.list.map((item, index) => {
          return (
            <Button key={index} variant={'choice'}
                    className={(isChecked(index) ? 'active' : '') + (item.icon ? ' with-icon' : '')}
                    onClick={() => handleSelect(item, index)}>
              {
                item.icon &&
                <i>{item.icon}</i>
              }

              {
                item.image &&
                <div className={'thumb'}>
                  <img src={item.image} alt="" className={'mw-100 w-100'}/>
                  {
                    // <img src={process.env.PUBLIC_URL + '/static/img/' + item.image} alt="" width={72} height={72} />

                    // survey.multiple &&
                    // <Checkbox checked={isChecked(index)}/>
                  }
                </div>
              }

              {
                (item.title || typeof item === 'string') &&
                <em className={item.icon ? 'text-start' : undefined} dangerouslySetInnerHTML={{__html: item.title || item}}/>
              }

              {
                // item.note &&
                // <span className={'note lg'}>{item.note}</span>
              }

              {
                // [SurveyEnum.checkbox, SurveyEnum.line, SurveyEnum.checkboxInline].includes(survey.type)
                survey.multiple && !item.image &&
                <Checkbox checked={isChecked(index)}/>
              }
            </Button>
          )
        })
      }
      {children}
    </div>
  )
}
